module.exports = __webpack_public_path__ + "static/media/MOSFET_board_2_options_bg_compressed.e0b4f3e2.jpg";